<template>
    <section class="content-process-inventory-sidebar" v-show="upFileExcelShow.show">

        <div class="content-process-inventory-sidebar-section-close" @click="manegeView(false)"></div>

        <div id="mySidenav" class="process-inventory-sidebar p-3 pt-4 mt-4 z-10">

            <br />

            <b-button variant="light" @click="manegeView(false)" class=" d-flex align-items-center">
                <i class="fa fa-chevron-left p-0 mr-2"></i>
                CERRAR VISTA
            </b-button>

            <h3 class="mt-3"><strong>Procesamiento de plantilla diligenciada para {{ getTitleToAction }}</strong></h3>
            <b-alert show variant="info">
                <i class="fa fa-info-circle mr-1"></i> Esta acción solo afectara:
                <ul v-if="upFileExcelShow.action === 'UPDATE'">
                    <i>Disponibilidad en el inventario</i>.
                    <i>Asignación de ubicaciones</i>.
                    <i>Asignación de campos personalizados</i>.
                </ul>
                <ul v-else>
                    <i>Creación de productos: (Nombre, Fabricante, Disponibilidad en inventario)</i>.
                    <i>Asignación de ubicaciones</i>.
                    <i>Asignación de campos personalizados</i>.
                </ul>
            </b-alert>
            <b-alert show variant="warning">
                <p class="m-0"><i class="fa fa-info-circle mr-1"></i> El archivo excel a cargar debió ser generado previamente desde el módulo de Inventario y para la Empresa actual. Generar plantilla <strong>Actualizar inventario</strong>
                    <b-button variant="outline-primary" class="ml-2" size="sm" @click="onHandleGoToDownloadTemplate">
                        <i class="fa fa-download mr-1"></i>aquí
                    </b-button>
                </p>
            </b-alert>
            <b-alert v-if="isProcessing" show variant="danger">
                <i class="fa fa-exclamation-triangle mr-1"></i> 
                <strong>Atención:</strong> Ya tienes un proceso de carga en curso. Por favor espera a que finalice para iniciar uno nuevo.
            </b-alert>

            <!-- Formulario -->
            <b-form @submit.prevent="onSubmit" enctype="multipart/form-data">
                <div class="bg-white p-2 rounded">
                    <b-form-group id="group-file-excel" label="Documento excel (*)" label-for="file-excel"
                        description="Solo se permiten el tipo de archivos: .xls, .xlsx.">
                        <b-form-file id="file-excel" v-model="form.file" accept=".xls,.xlsx,.ods"
                            ref="fileExcelProducts" class="mb-2" placeholder="Cargar documento excel..."
                            required></b-form-file>
                    </b-form-group>

                    <!-- Botones de acciones -->
                    <div class="d-flex align-items-center justify-content-between">
                        <b-button :disabled="!form.file" variant="light" @click.prevent="clearFiles">
                            <i class="fa fa-refresh mr-1"></i>
                            Nueva carga
                        </b-button>
                        <b-button :disabled="!form.file || isProcessing || (form.file && typeof responseUpFileExcelProducts !== 'object') || (form.file && responseUpFileExcelProducts && typeof responseUpFileExcelProducts === 'object' && responseUpFileExcelProducts.length > 0)" variant="primary" @click.prevent="onSubmit">
                            <i class="fa fa-upload mr-1"></i>
                            Cargar documento
                        </b-button>
                    </div>
                </div>
            </b-form>

            <b-card no-body class="mt-3 border-0">
                <b-tabs class="bg-white border-0" type="pills">

                    <!-- Registro del proceso actual -->
                    <b-tab title="Registros del proceso actual" class="border-0">
                        <ProductosMasivoAgendados :importes="importesAgendados" />
                    </b-tab>

                     <!-- Histórico de procesos -->
                     <b-tab title="Histórico de procesos" class="border-0">
                        <b-table :busy="historyRegistersProductsLoading" hover :items="historyRegistersProducts.data" :fields="fieldsHistory" responsive="sm" select-mode="multi" small selectable bordered show-empty>
                            <template #empty="scope">
                                <p class="text-muted text-center mt-3"><i class="fa fa-list mr-1"></i>No hay resultados para mostrar...</p>
                            </template>

                            <template #table-busy>
                                <div class="text-center my-2">
                                    <i class="fa fa-history mr-1"></i>
                                    <strong>Cargando registros, por favor espera...</strong>
                                </div>
                            </template>

                            <!-- Producto -->
                            <template #cell(product)="data">
                                <small class="text-primary">{{ data.item.next_data_products.name }}</small>
                            </template>

                            <!-- Fabricante -->
                            <template #cell(manufacturer)="data">
                                <small>{{ data.item.next_data_products.manufacturer }}</small>
                            </template>

                            <!-- Responsable -->
                            <template #cell(responsible)="data">
                                <small>{{ data.item.responsible.name }}</small>
                            </template>

                            <!-- Fecha -->
                            <template #cell(date)="data">
                                <small>{{ data.item.created_at }}</small>
                            </template>

                            <!-- Ver detalles -->
                            <template #cell(details)="data">
                                <b-button variant="outline-primary" size="sm" @click="data.toggleDetails" class="mr-2">
                                {{ data.detailsShowing ? 'Ocultar' : 'Ver'}} detalles
                                </b-button>
                            </template>

                            <!-- Detalles del proceso -->
                            <template #row-details="data">
                                <div class="px-2 mt-2" v-if="upFileExcelShow.action === 'UPDATE'">
                                    <strong class="text-danger">Estado anterior</strong>
                                    <ItemListDetailsChanges :data="data.item.prev_data_products" />
                                </div>
                                <div class="px-2">
                                    <strong class="text-primary" v-if="upFileExcelShow.action === 'UPDATE'">Estado actual</strong>
                                    <ItemListDetailsChanges :data="data.item.next_data_products" />
                                </div>
                                <b-button class="mb-1 ml-2" variant="outline-primary" size="sm" @click="data.toggleDetails">Ocultar Detalles</b-button>
                            </template>

                        </b-table>

                        <!-- Paginar tabla -->
                        <el-pagination class="float-right" v-model="historyRegistersProducts.current_page" @size-change="onHandleChangePerPage"
                            @current-change="onHandleChangePage" :current-page="historyRegistersProducts.current_page" :page-sizes="[10, 30, 50, 100]"
                            :page-size="Number(historyRegistersProducts.per_page)" layout="total,sizes, prev, pager, next" :total="historyRegistersProducts.total"
                        />

                    </b-tab>

                    <br />
                    <br />

                </b-tabs>
            </b-card>

        </div>

    </section>
</template>
<script>

// Importaciones generales
import { mapState, mapMutations, mapActions } from 'vuex';
import Pusher from 'pusher-js';
import { getUuidToUser } from '@/plugins/acl';

// Componentes
import ItemListDetailsChanges from './ItemListDetailsChanges';
import ProductosMasivoAgendados from './ProductosMasivoAgendados';

export default {
    name: 'UpFromFileContentView',

    components: {
        ItemListDetailsChanges,
        ProductosMasivoAgendados
    },

    data() {
        return {
            form: {
                file: null,
            },
            fields: [
                {
                    key: 'row',
                    label: 'FILA',
                    sortable: true
                },
                {
                    key: 'product',
                    label: 'PRODUCTO',
                    sortable: true
                },
                {
                    key: 'manufacturer',
                    label: 'FABRICANTE',
                    sortable: true
                },
                {
                    key: 'errors',
                    label: 'ERRORES'
                }
            ],
            fieldsHistory: [
                {
                    key: 'product',
                    label: 'PRODUCTO',
                    sortable: true
                },
                {
                    key: 'manufacturer',
                    label: 'FABRICANTE',
                    sortable: true
                },
                {
                    key: 'responsible',
                    label: 'RESPONSABLE',
                    sortable: true
                },
                {
                    key: 'date',
                    label: 'FECHA',
                    sortable: true
                },
                {
                    key: 'details',
                    label: 'DETALLES',
                    _showDetails: true
                },
            ],
            fieldsHistoryDetails: [
                {
                    key: 'available_in_inventory',
                    label: 'DIsponible en inventario',
                    sortable: false
                },
                {
                    key: 'location',
                    label: 'Ubicaciones',
                    sortable: false
                },
                {
                    key: 'custom_fields',
                    label: 'Campos personalizados',
                    sortable: false
                }
            ]
        }
    },

    mounted() {
        this.subscribeToNotifications();
    },

    beforeDestroy() {
        this.unsubscribeFromNotifications();
    },

    watch: {

        'form.file'(nextState, prevState) {
            if (nextState !== prevState) {
                if (!nextState) this.setResponseUpFileExcelProducts(null);
            }
        },

        'upFileExcelShow.show'(nextState) {
            if (nextState) {
                this.listarImportesAgendadosProductos({ company: this.filterProducts.empresa, action: this.upFileExcelShow.action });
                this.getHistory(1, 10);
            }
        }

    },

    computed: {

        ...mapState('productos', {
            filterProducts: 'filtro',
            upFileExcelShow: 'upFileExcelShow',
            responseUpFileExcelProducts: 'responseUpFileExcelProducts',
            historyRegistersProductsLoading: 'historyRegistersProductsLoading',
            historyRegistersProducts: 'historyRegistersProducts',
            importesAgendados: 'importesAgendados'
        }),

        getTitleToAction() {
            return this.upFileExcelShow.action === 'UPDATE' ? 'Actualizar inventario' : 'Crear inventario';
        },

        isProcessing() {
            if (!this.importesAgendados) return false;
            return this.importesAgendados.some(i => i.estado_procesamiento === 'AGENDADO' || i.estado_procesamiento === 'PROCESANDO');
        }

    },

    methods: {

        ...mapActions('productos', [
            'upFileToUpdateProducts',
            'getHistoryUpdateProducts',
            'listarImportesAgendadosProductos'
        ]),

        ...mapMutations('productos', [
            'setUpFileExcelShow',
            'setResponseUpFileExcelProducts',
            'setHistoryRegistersProducts'
        ]),

        onHandleChangePerPage(pagePage) {
            this.getHistory(this.historyRegistersProducts.current_page, pagePage)
        },

        onHandleChangePage(page) {
            this.getHistory(page, this.historyRegistersProducts.per_page)
        },

        async manegeView(isShow) {
            this.clearFiles()
            this.setUpFileExcelShow({
                show: isShow,
                action: 'UPDATE'
            });
        },

        clearFiles() {
            if (this.form.file) this.$refs['fileExcelProducts'].reset()
            this.setResponseUpFileExcelProducts(null);
        },

        async onSubmit(event) {
            event.preventDefault()

            if (this.form.file.size > 20 * 1024 * 1024) { // 20480 kilobytes = 20 MB
                this.$alertError('El tamaño máximo para el archivo es de 20Mb', 5000, true, 'Procesamiento de inventario', 'info')
                return false
            }

            const uuid = getUuidToUser();

            await this.upFileToUpdateProducts({
                action: this.upFileExcelShow.action,
                companyId: this.filterProducts.empresa,
                file: this.form.file,
                uuid: uuid,
                callback: this.onHandleCallbackToLoadHistory
            })
        },

        onHandleGoToDownloadTemplate() {
            this.$router.push('/generate-report-inventory');
        },

        onHandleCallbackToLoadHistory(status) {
            if (status) {
                this.getHistory(1, 10);
                this.listarImportesAgendadosProductos({ company: this.filterProducts.empresa, action: this.upFileExcelShow.action });
            }
        },

        subscribeToNotifications() {
            const uuid = getUuidToUser();
            if (!uuid) return;

            this.pusher = new Pusher('5c41c1dc4bec329b2165', {
                cluster: 'us2'
            });

            const channel = this.pusher.subscribe(uuid);
            channel.bind('notificaciones', (data) => {
                // Si la notificación es de carga de productos, refrescamos la lista
                if (data.mensaje && (data.mensaje.titulo.includes('Carga de productos') || data.mensaje.titulo.includes('Error en carga'))) {
                    this.listarImportesAgendadosProductos({ company: this.filterProducts.empresa, action: this.upFileExcelShow.action });
                    this.getHistory(1, 10);
                }
            });
        },

        unsubscribeFromNotifications() {
            if (this.pusher) {
                const uuid = getUuidToUser();
                if (uuid) this.pusher.unsubscribe(uuid);
                this.pusher.disconnect();
            }
        },

        async getHistory(current_page, per_page) {
            await this.getHistoryUpdateProducts({
                current_page,
                per_page,
                company_id: this.filterProducts.empresa,
                action: this.upFileExcelShow.action
            })
        }

    },
}
</script>

<style scoped>
.content-process-inventory-sidebar {
    position: absolute;
    right: 0;
    width: 102%;
    height: calc(100% + 48pt);
    overflow: auto;
    background: #f4f4f4ba;
    top: -21px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    overflow: hidden;
}

.content-process-inventory-sidebar-section-close {
    width: calc(100% - 479pt);
    height: calc(100% + 48pt);
}

.process-inventory-sidebar {
    height: 100vh;
    width: 700pt;
    position: fixed;
    z-index: 1;
    top: 0;
    right: 0;
    background-color: #f2f2f2;
    overflow-x: hidden;
    padding-top: 60px;
    -webkit-transition: 0.5s;
    transition: 0.5s;
    overflow-y: auto;
    box-shadow: -4px 0 16px -3px #00000052;
}

@media (min-width: 0pt) and (max-width: 700pt) {
    .process-inventory-sidebar {
        height: 100vh;
        width: 100%;
        left: 0;
    }
}

</style>
